import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import image3 from "../Images/image3.jpg";

const services = [
  {
    title: "3D Printing",
    description: [
      "Rapid prototyping for startups and businesses",
      "Batch production (toys, home décor, lamps, fidget toys, industrial parts)",
      "On-demand spare parts & components",
      "High precision with industrial-grade printers",
    ],
  },
  {
    title: "Fabrication",
    description: [
      "Acrylic fabrication (displays, enclosures, models)",
      "Laser cutting & engraving (precision parts, custom designs)",
      "Fixtures, jigs, housings, and enclosures for industries",
    ],
  },
  {
    title: "Materials We Work With",
    description: [
      "PLA",
      "PETG",
      "ABS",
      "ASA",
      "Nylon",
      "Resin",
      "ABS Resin",
      "TPU (flexible)",
    ],
  },
  {
    title: "Industries We Serve",
    description: [
      "Startups & Product Designers",
      "Architecture & Interior Design",
      "Automotive & Engineering",
      "Electronics & IoT",
      "Medical & Healthcare Devices",
      "Artists, Toy & Lifestyle Brands",
      "Manufacturing (fixtures, jigs, housings, tooling, enclosures)",
    ],
  },
];

const Services = () => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(${image3})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        color: "#fff",
        py: 10,
        px: { xs: 3, sm: 6, md: 12 },
        minHeight: "20vh",
      }}
    >
      {/* Dark overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.6)",
          zIndex: 1,
        }}
      />

      {/* Content goes above overlay */}
      <Box sx={{ position: "relative", zIndex: 2 }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            textAlign: "center",
            mb: 6,
            fontSize: { xs: "2rem", sm: "2.5rem" },
          }}
        >
          What We Can Do for You
        </Typography>

        <Grid container justifyContent="center">
          {services.map((service, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              key={index}
              sx={{
                width: "50rem",
                borderTop: index > 1 ? "1px solid #2c2c2c" : "none",
                borderLeft: index % 2 === 1 ? "1px solid #2c2c2c" : "none",
                backgroundColor:
                  index % 2 === 0
                    ? "rgba(26, 26, 26, 0.8)"
                    : "rgba(18, 18, 18, 0.8)",
                p: { xs: 3, sm: 4 },
                minHeight: "220px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Box
                  sx={{
                    width: "4px",
                    height: "20px",
                    backgroundColor: "rgb(198, 40, 40)",
                    mr: 1.5,
                  }}
                />
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{ color: "#fff" }}
                >
                  {service.title}
                </Typography>
              </Box>

              {Array.isArray(service.description) ? (
                <ul
                  style={{
                    margin: 0,
                    paddingLeft: "1.2rem",
                    color: "#ccc",
                  }}
                >
                  {service.description.map((point, i) => (
                    <li
                      key={i}
                      style={{ marginBottom: "0.5rem", lineHeight: 1.6 }}
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              ) : (
                <Typography
                  variant="body2"
                  sx={{ color: "#ccc", lineHeight: 1.6 }}
                >
                  {service.description}
                </Typography>
              )}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Services;
